import { render, staticRenderFns } from "./ContractProductForm.vue?vue&type=template&id=55316016&scoped=true&"
import script from "./ContractProductForm.vue?vue&type=script&lang=js&"
export * from "./ContractProductForm.vue?vue&type=script&lang=js&"
import style0 from "./ContractProductForm.vue?vue&type=style&index=0&id=55316016&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55316016",
  null
  
)

export default component.exports